import CatalogueItem from './CatalogueItem';
import { CatalogueItem as CatalogueItemType } from './types';
import { isEmpty } from 'lib/javascript';

interface CatalogueItemsProps {
  items?: CatalogueItemType[];
}

const CatalogueItems = ({ items }: CatalogueItemsProps) => {
  if (isEmpty(items)) {
    return (
      <p className="tw-italic tw-text-center">
        Something YUMMY is coming soon!
      </p>
    );
  }
  return (
    <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-5">
      {items?.map((item) => (
        <CatalogueItem key={item.id} item={item} />
      ))}
    </div>
  );
};

export default CatalogueItems;
